// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1-HNO","list":"styles_list__22pu3"};